import { render, staticRenderFns } from "./decorate.vue?vue&type=template&id=73fa6470&scoped=true"
import script from "./decorate.vue?vue&type=script&lang=js"
export * from "./decorate.vue?vue&type=script&lang=js"
import style0 from "./decorate.vue?vue&type=style&index=0&id=73fa6470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa6470",
  null
  
)

export default component.exports